import i18n from "~/i18n";
import { types } from "./ConversationContent/types/index.jsx";

export const getGroupConversationDisplayName = (name = "", users = [], long = false) => {
  if (name?.length) {
    return name;
  }

  if (!Array.isArray(users)) {
    throw new TypeError(`users expected array, received: ${typeof users}`);
  }

  if (users.length === 0) {
    return "Group";
  }

  if (long) {
    return users.map((user) => user?.first_name).join(", ");
  }

  const firstUserName = users[0]?.first_name;
  const secondUserName = users[1]?.first_name;

  if (users.length === 1) {
    return firstUserName;
  } else if (users.length === 2) {
    return firstUserName + " " + i18n.t("and") + " " + secondUserName;
  } else if (users.length === 3) {
    const thirdUserName = users[2]?.first_name;
    return firstUserName + ", " + secondUserName + " " + i18n.t("and") + " " + thirdUserName;
  }

  return i18n.t("{{firstUserName}}, {{secondUserName}} and {{number}} others", {
    firstUserName,
    secondUserName,
    number: users.length - 2,
  });
};

export const getOwnConversationName = (users = {}, loggedUserId = 0) => {
  const loggedUser = users[loggedUserId];
  return loggedUser?.display_name || i18n.t("Anonymous User");
};

export const getGeneralConversationName = () => {
  return "General";
};

export const getGroupConversationName = (members = [], loggedUserId = 0, users = {}, name) => {
  const conversationMembers = members
    .filter((memberId) => memberId !== loggedUserId)
    .reduce((acc, memberId) => {
      const user = users[memberId];
      if (user) {
        acc.push(user);
      }
      return acc;
    }, []);
  return getGroupConversationDisplayName(name, conversationMembers);
};

export const getOneToOneConversationName = (members = [], users = {}, loggedUserId = 0) => {
  const id = members.find((id) => id !== loggedUserId);
  const user = users[id];
  return user?.display_name || i18n.t("Anonymous User");
};

export const getConversationName = (conversation = {}, users = {}, loggedUserId = 0) => {
  const { name = "", members = [], class: type } = conversation;
  const conversationType = types[type];

  switch (conversationType) {
    case "GeneralConversation": {
      return getGeneralConversationName();
    }
    case "OwnConversation": {
      return getOwnConversationName(users, loggedUserId);
    }
    case "OneToOneConversation": {
      return getOneToOneConversationName(members, users, loggedUserId);
    }
    case "GroupConversation": {
      return getGroupConversationName(members, loggedUserId, users, name);
    }
    default: {
      return name;
    }
  }
};
